import {
    Box,
    Typography,
    Button
} from '@mui/material'
import { Image } from 'antd'
import IMG404 from '../../assets/404.png'
import { isDesktop, isMobile, isTablet } from 'react-device-detect'

export const SM404: React.FC = () => {

    const gotoHome = () => {
        window.location.replace('/')
    }

    const image404 = () => {
        if (isMobile) {
            if (isTablet) {
                return (<Image src={IMG404} width={453} height={404} alt='' preview={false}></Image>)
            } else {
                return (<Image src={IMG404} alt='' preview={false} style={{ paddingLeft: '100px', paddingRight: '100px' }}></Image>)
            }

        } else {
            return (<Image src={IMG404} width={453} height={404} alt='' preview={false}></Image>)
        }
    }

    // ======================= VIEWS
    return (
        <Box sx={{
            width: '100%',
            display: 'flex',
            paddingBottom: '100px',
            flexDirection: 'column',
            justifyContent: 'center',
            alignContent: 'center',
            alignItems: 'center'
        }}>
            {image404()}

            <Typography fontSize={isDesktop ? 32 : 22} fontWeight={700} color={'#141F39'} textAlign={'center'} paddingTop={'10px'}>
                Page not found
            </Typography>

            <Typography fontSize={isDesktop ? 16 : 14} fontWeight={400} color={'#6B6B6B'} textAlign={'center'} paddingTop={isDesktop ? '80px' : '40px'} paddingBottom={isDesktop ? '40px' : '30px'}>
                The page you were looking for could not be found.
            </Typography>

            <Button
                onClick={() => gotoHome()}
                sx={{
                    borderRadius: '30px',
                    bgcolor: '#FFC107',
                    color: '#141F39',
                    '&:hover': {
                        bgcolor: '#FFC107',
                    },
                    height: isDesktop ? '60px' : '50px',
                    paddingLeft: '24px',
                    paddingRight: '24px',
                    textTransform: 'none',
                    fontSize: isDesktop ? '16px' : '14px',
                    fontWeight: 500
                }}
            >
                Return To Homepage
            </Button>

        </Box>
    )
}

// ======================= EXPORT
export default SM404
